////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.6                                                            //
//  Summary: Synchronises document.title + canonical link with the route    //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import { useEffect } from 'react';

import { useCanonical } from '@/lib/seo';

const SITE_NAME = 'IRONSIDE';

/** `document.title` is a genuine external system (the browser chrome/tab), so an
 * effect — not a render-time assignment — is the correct tool. Restores the
 * previous title on cleanup so an unmounting route never leaves a stale title
 * behind for whatever renders next. */
export function usePageTitle (title: string): void {
  // Every routed page calls this hook, which is exactly the "per route" contract
  // the canonical link needs (1.0.6.md §2.3) — one call site, no page edits.
  // Keyed on `title` so a same-component route change (e.g. /news/:slug) recomputes.
  useCanonical(title);

  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    return () => { document.title = previous; };
  }, [title]);
}
